import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'
import RolePermissionsV2 from './RolePermissionsV2'

function RolesList() {
  // return <List />
  return <RolePermissionsV2 />
}

export default hipladeTemplate(RolesList)
